var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('projent-card',{attrs:{"projent":_vm.project,"type":"project","withPlace":_vm.withPlace,"withLocation":_vm.withLocation}})}
var staticRenderFns = []

export { render, staticRenderFns }